export const getFormattedDateMDY = (date: Date) => new Intl.DateTimeFormat('en-US', {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
})
  .format(date);

export const DAYTIME_TIMINGS = ['morning', 'afternoon'];

/**
 * True when at least one row has a non-after-hours (8am-4pm) window selected.
 * The dates offered are already weekdays only, so no day-of-week check is needed.
 */
export const hasDaytimeAvailability = (
  availabilities?: Array<{ timings?: string[] }>,
) => (availabilities || []).some(
  (availability) => (availability?.timings || []).some(
    (timing) => DAYTIME_TIMINGS.includes(timing),
  ),
);

type ErrorObject = {
  [key: string]: any;
};

export const handleErrorMessages = (
  error: any[] | ErrorObject,
  callback: (errorString: string
  ) => void,
) => {
  const errorMsg: string[] = [];

  const errorMessage = (err: any) => {
    if (Array.isArray(err)) {
      err.forEach((item) => {
        errorMessage(item);
      });
    } else if (typeof err === 'object' && err !== null) {
      Object.keys(err).forEach((item) => {
        errorMessage(err[item]);
      });
    } else if (typeof err === 'string') {
      errorMsg.push(err);
    }
  };

  errorMessage(error);

  if (errorMsg?.length > 0) {
    callback(errorMsg.join(', '));
  } else {
    callback('Something went wrong, please try again later.');
  }
};
